import { HttpHeaders } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators, UntypedFormGroup } from '@angular/forms';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiService } from 'src/services/apiService';
import { AuthService } from 'src/services/auth.service';

@Component({
  selector: 'app-exemptions',
  templateUrl: './exemptions.component.html',
  styleUrls: ['./exemptions.component.css']
})
export class ExemptionsComponent {
  //GetAllExemptionList
  requests:any[]=[];
  pages: number[] = [];
  currentIndex=1;

  taxNumber:string|undefined="";
  licenseId:string|undefined="";

  token:string;
  isLoading=false;
  mainPath = "" // قراءة القيمة من environment

  visible: boolean = false;
  currentExmpId:string|undefined;
  isClick=false;
  minioId:string|undefined;

  stopForm = new UntypedFormGroup({
    stopReason: new FormControl('',Validators.required),
    attachment: new FormControl('',Validators.required),
  });

  constructor(private apiService:ApiService,private authService:AuthService) {
    this.mainPath= environment.MainPath;

    this.fillRequest();
    this.token=this.authService.getToken()!;

  }

  fillRequest(){

    this.isLoading=true;

    
    var request=this.apiService.get('Moin/GetAllExemptionList',environment.govnet);

    request.subscribe(response=>{

      this.requests=response.data.records;

      this.isLoading=false;
      
      for (let i = 1; i <= response.data.totalPages; i++) {
        this.pages.push(i);
      }

    });

  }

  showDialog(currentExmpId:string) {
    this.currentExmpId=currentExmpId;
    this.visible = true;
  }

  onUploadFile(event:any) {

    this.isLoading=true;

    var files=event.target.files as any[];

    for(var i=0;i<files.length;i++){

        this.uploadFileAndGetObjectName(files[i]).subscribe(response=>{
        
        setTimeout(() =>{
          this.isLoading=false;
        },2000);

        this.minioId = response;

      });

    }

   // event.target.value = '';

  }

  uploadFileAndGetObjectName(file: any): Observable<string> {
    return this.apiService.uploadFile(file, '12345').pipe(
      map((response: any) => response.data.path)
    );
  }

  stopLicense(){

    this.isClick=true;

    if(this.stopForm?.valid){

      this.isClick=false;



      var body={
        "model":{
          licenseId:this.currentExmpId,
          employeeId:this.authService.getNationalNumber(),
          stopReason:this.stopForm.get('stopReason')?.value,
          minioId:this.minioId,
        }
      };


      var request= this.apiService.post('Moin/StopLicense',body,environment.govnet);

      request.subscribe(resposne=>{

        this.currentExmpId=undefined;
        this.visible=false;
        this.stopForm.reset();
        this.fillRequest();

      });

    }else{
      console.log(this.stopForm);
    }
  }

  downloadMinioFile(objectId:string){

    var request=this.apiService.minioRedirectFile(objectId);

  }

  search(){

    this.isLoading=true;

    this.pages=[];

    var url="Moin/GetAllExemptionList?";

    if(this.taxNumber!=""){
      url+=`TaxNumber=${this.taxNumber}&`;
    }

    if(this.licenseId!=""){
      url+=`LicenseId=${this.licenseId}&`;
    }

    var request=this.apiService.get(url,environment.getterLink);

    request.subscribe(response=>{
      this.requests=response.records;

      this.isLoading=false;
      
      for (let i = 1; i <= response.data.totalPages; i++) {
        this.pages.push(i);
      }
    });

  }


  goNextIndex(){

    if(this.currentIndex<this.pages.length){
      var newIndex=this.currentIndex+1;
  
      this.updatePagination(newIndex);
    }
  }

  goPrevIndex(){

    if(this.currentIndex!=1){

      var newIndex=this.currentIndex-1;

      this.updatePagination(newIndex);
    }
  }


  updatePagination(index:number){


    this.isLoading=true;

    var request=this.apiService.get(`Moin/GetAllExemptionList?PageSize=10&PageNumber=${index}`,environment.govnet);

    this.currentIndex=index;

    request.subscribe(response=>{

      this.isLoading=false;

      this.requests=response.data.records;

    

    });
  }


}
